import React from 'react';

import { SkeletonProvider } from '../context/LoadingSkeletonContext';
import type { SkeletonShapeProps } from '../types';

type Props = {
	loading?: boolean;
	className?: string;
	shapeColorClassName?: string;
	shapeSize?: SkeletonShapeProps['size'];
	children?: React.ReactNode;
};

export function SkeletonContainer(props: Props) {
	const { className = '', loading = false, shapeColorClassName = '', shapeSize = 'medium', children } = props;

	return (
		<div className={className}>
			<SkeletonProvider loading={loading} shapeColorClassName={shapeColorClassName} shapeSize={shapeSize}>
				{children}
			</SkeletonProvider>
		</div>
	);
}
